import React, { useEffect } from "react";
import "./style.scss";
import Subtab from "../Subtab";
import UsersLeaderboard from "../UsersLeaderboard";
import UnitLeaderboard from "../UnitLeaderboard";

const ContentLeaderboard = (p) => {
  return (
    <div className="content-leaderboard">
      <Subtab {...p} />
      {p.activeSubtab == "users" && <UsersLeaderboard {...p} />}
      {p.activeSubtab == "unit" && <UnitLeaderboard {...p} />}
    </div>
  );
};

export default ContentLeaderboard;
